import moment from 'moment';
import { reactLocalStorage } from 'reactjs-localstorage';
import {
  ADD_ORDER_INFO,
  ADD_POS_ORDER,
  ADD_WAITING_ORDER,
  REMOVE_OLD_POS_ORDER,
  REMOVE_OLD_WAITING_ORDER,
  REMOVE_ORDER_INFO,
  REMOVE_ORDER_INFO_ALL,
  REMOVE_POS_ORDER,
  REMOVE_POS_ORDER_ALL,
  REMOVE_POS_ORDER_BY_ORDERCODE,
  REMOVE_POS_ORDER_BY_ORDER_AWAIT_ID,
  REMOVE_WAITING_ORDER,
  REMOVE_WAITING_ORDER_ALL,
  REMOVE_WAITING_ORDER_BY_ORDERCODE,
  REMOVE_WAITING_ORDER_BY_ORDER_AWAIT_ID,
  SET_KEYBOARD_SETTING,
  SET_MULTI_POS_SETTING,
  SET_VOLUME_SETTING,
  UPDATE_POS_ORDER,
  UPDATE_WAITING_ORDER,
} from '../actions/posAction';
import Const from '../const';
import {createOrderInfoAtCloudFlareWorker} from "../api/api";

const INITIAL_STATE = {
  posIdx: 0,
  posOrders: [],
  waitingIdx: 1000,
  waitingOrders: [],
  orderInfos: [],
  keyboardSetting: false,
  volume: 0.3,
  orderStatusTable: false,
  multiPosSetting: false,
  simpleDongSetting: true,
};

const posReducer = (state = INITIAL_STATE, action) => {
  let result;
  let idx;
  switch (action.type) {
    case ADD_POS_ORDER:
      result = Object.assign({}, state);
      result.posOrders.push({ ...action.order, idx: ++result.posIdx });
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#posOrder',
          result.posOrders
        );
      }
      return result;
    case REMOVE_POS_ORDER:
      result = Object.assign({}, state);
      idx = result.posOrders.findIndex((x) => x.idx === action.idx);
      if (idx >= 0) result.posOrders.splice(idx, 1);
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#posOrder',
          result.posOrders
        );
      }
      return result;
    case REMOVE_POS_ORDER_BY_ORDERCODE:
      result = Object.assign({}, state);
      idx = result.posOrders.findIndex(
        (x) => x.isBaeminOrder && x.orderCode === action.orderCode
      );
      if (idx >= 0) result.posOrders.splice(idx, 1);
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#posOrder',
          result.posOrders
        );
      }

      return result;
    case REMOVE_POS_ORDER_ALL:
      result = {
        ...state,
        posOrders: [],
      };
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#posOrder',
          result.posOrders
        );
      }
      return result;

    case ADD_WAITING_ORDER:
      result = Object.assign({}, state);
      result.waitingOrders.push({ ...action.order, idx: ++result.waitingIdx });
      return result;
    case UPDATE_WAITING_ORDER:
      result = Object.assign({}, state);
      if (action.order.id) {
        idx = result.waitingOrders.findIndex((x) => x.id === action.order.id);
      } else {
        idx = result.waitingOrders.findIndex((x) => x.idx === action.order.idx);
      }

      if (idx >= 0) {
        result.waitingOrders[idx] = action.order;
      }
      return result;

    case UPDATE_POS_ORDER:
      result = Object.assign({}, state);
      if (action.order.id) {
        idx = result.posOrders.findIndex((x) => x.id === action.order.id);
      } else {
        idx = result.posOrders.findIndex((x) => x.idx === action.order.idx);
      }

      if (idx >= 0) {
        result.posOrders[idx] = action.order;
      }
      return result;

    case REMOVE_WAITING_ORDER:
      result = Object.assign({}, state);

      idx = result.waitingOrders.findIndex((x) => x.idx === action.idx);
      if (idx >= 0) result.waitingOrders.splice(idx, 1);
      return result;
    case REMOVE_WAITING_ORDER_BY_ORDER_AWAIT_ID:
      result = Object.assign({}, state);

      idx = result.waitingOrders.findIndex((x) => x.id === action.id);
      if (idx >= 0) result.waitingOrders.splice(idx, 1);
      return result;

    case REMOVE_POS_ORDER_BY_ORDER_AWAIT_ID:
      result = Object.assign({}, state);

      idx = result.posOrders.findIndex((x) => x.id === action.id);
      if (idx >= 0) result.posOrders.splice(idx, 1);
      // if (!action.noSave) {
      //   reactLocalStorage.setObject(
      //     Const.appName + "#posOrders",
      //     result.posOrders
      //   );
      // }
      return result;

    case REMOVE_WAITING_ORDER_BY_ORDERCODE:
      result = Object.assign({}, state);
      idx = result.waitingOrders.findIndex(
        (x) => x.isBaeminOrder && x.orderCode === action.orderCode
      );
      if (idx >= 0) result.waitingOrders.splice(idx, 1);
      return result;
    case REMOVE_WAITING_ORDER_ALL:
      result = {
        ...state,
        waitingOrders: [],
      };
      return result;

    case ADD_ORDER_INFO:
      result = Object.assign({}, state);
      const index = result.orderInfos.findIndex((x) => x.metadata.id === action.info.metadata.id);

      if (index < 0) {
        result.orderInfos.push(action.info);
      }
      if (!action.noSave) {
        const orderInfos = [...result.orderInfos];
        if (result.orderInfos.length > 10000) {
          orderInfos.splice(0, result.orderInfos.length - 10000);
        }
        createOrderInfoAtCloudFlareWorker(action.info).then();
      }
      return result;
    case REMOVE_ORDER_INFO:
      result = Object.assign({}, state);
      idx = result.orderInfos.findIndex((x) => x.id === action.id);
      if (idx >= 0) result.orderInfos.splice(idx, 1);
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#orderInfo',
          result.orderInfos
        );
      }
      return result;
    case REMOVE_ORDER_INFO_ALL:
      result = {
        ...state,
        orderInfos: [],
      };
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#orderInfo',
          result.orderInfos
        );
      }
      return result;

    case SET_KEYBOARD_SETTING:
      result = {
        ...state,
        keyboardSetting: action.keyboardSetting,
      };
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#keyboardSetting',
          action.keyboardSetting
        );
      }
      return result;

    case SET_MULTI_POS_SETTING:
      result = {
        ...state,
        multiPosSetting: action.multiPosSetting,
      };
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#multiPosSetting',
          action.multiPosSetting
        );
      }
      return result;

    case SET_VOLUME_SETTING:
      result = {
        ...state,
        volume: action.volume,
      };
      if (!action.noSave) {
        reactLocalStorage.setObject(Const.appName + '#volume', action.volume);
      }
      return result;

    case REMOVE_OLD_POS_ORDER:
      result = {
        ...state,
        posOrders: Object.assign({}, state).posOrders.filter(
          (x) =>
            moment().format('YYYY-MM-DD') <
            moment(x.orderDate).add(2, 'd').format('YYYY-MM-DD')
        ),
      };
      if (!action.noSave) {
        reactLocalStorage.setObject(
          Const.appName + '#posOrder',
          result.posOrders
        );
      }
      return result;

    case REMOVE_OLD_WAITING_ORDER:
      result = {
        ...state,
        waitingOrders: Object.assign({}, state).waitingOrders.filter(
          (x) =>
            moment().format('YYYY-MM-DD') <
            moment(x.orderDate).add(2, 'd').format('YYYY-MM-DD')
        ),
      };
      return result;

    // case SET_ORDER_STATUS_TABLE_SETTING:
    //   result = {
    //     ...state,
    //     orderStatusTable: action.orderStatusTable,
    //   };
    //   if (!action.noSave) {
    //     reactLocalStorage.setObject(
    //       Const.appName + "#orderStatusTable",
    //       action.orderStatusTable
    //     );
    //   }
    //   return result;

    default:
      return state;
  }
};

export default posReducer;
